import { Link, useLocation } from "@tanstack/react-router";
import { Bot, Home, Settings, User } from "lucide-react";
import { Logo } from "@/components/brand/logo";
import { cn } from "@/lib/utils";
import { dashboardNavItems } from "../header/shared";

const iconMap = {
	home: Home,
	bot: Bot,
	settings: Settings,
	user: User,
} as const;

export function DashboardSidebar() {
	const location = useLocation();
	const normalizedPath = location.pathname.replace(/\/+$/, "");
	const lastSegment = normalizedPath.split("/").filter(Boolean).pop();
	const activeSegment =
		normalizedPath === "/dashboard"
			? ""
			: dashboardNavItems.some((item) => item.segment === lastSegment)
				? lastSegment
				: null;

	return (
		<aside className="hidden lg:flex lg:w-56 lg:flex-col lg:fixed lg:inset-y-0 lg:left-0 lg:z-40 lg:bg-card lg:border-r lg:border-border">
			<div className="flex h-14 items-center px-4 border-b border-border">
				<Logo size="sm" />
			</div>

			<div className="border-b border-border px-4 py-3">
				<span className="font-mono text-sm uppercase tracking-[0.14em] text-muted-foreground">
					&gt; Dashboard
				</span>
			</div>

			<nav className="flex-1 px-2 py-3 space-y-0.5">
				{dashboardNavItems.map((item) => {
					const Icon = iconMap[item.icon];
					const isActive = activeSegment === item.segment;

					return (
						<Link
							key={item.segment}
							to={item.path}
							aria-current={isActive ? "page" : undefined}
							className={cn(
								"flex items-center gap-2.5 border-l-2 px-3 py-2 font-mono text-sm uppercase tracking-[0.12em] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-inset",
								isActive
									? "border-brand bg-brand-soft text-brand"
									: "border-transparent text-muted-foreground hover:border-brand/40 hover:text-brand",
							)}
						>
							<Icon className="size-3.5 shrink-0" />
							{item.label}
						</Link>
					);
				})}
			</nav>
		</aside>
	);
}
